// extracted by mini-css-extract-plugin
export default {"suggestionsLabel":"hNiYQJ"};